import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=21e1a5cf&scoped=true&"
import script from "./BaseIcon.vue?vue&type=script&lang=js&"
export * from "./BaseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1a5cf",
  null
  
)

export default component.exports